export enum FeatureFlagOptions {
  PARTNER_PORTAL_HOME_PLAN = 'pp_home_plan',
  PARTNER_PORTAL_ACTIVATE_WARRANTY = 'pp_activate_warranty',
  PARTNER_CATALOGS = 'partner.catalogs',
  PARTNER_PORTAL_EXTENDED_WARRANTY_FOR_FIG = 'pp_extended_warranty_for_fig',
}
